{
	"continueWithoutMetadata": "Continue Without Photo Metadata",
	"defaultDescription": "We did not detect editing metadata in your photos. You can upload a preset to help AI better match your editing style, or simply let our AI Color Match algorithm create your style.",
	"defaultTitle": "Missing Edit Metadata",
	"uploadPreset": "Upload Preset",
	"useAiColorMatch": "Use AI Color Match To Create AI Style",
	"useAiColorMatchButton": "Use AI Color Match",
	"usePreset": "Use Preset To Create AI Style"
}
